import React, { memo, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.css';
import { Table, Loading } from '../../../../../common/ui';
import { getSuppliers } from '../../actions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const SupplierTable = memo(
  ({
    getSuppliers,
    auth: { branchId },
    suppliersState: { suppliersData, isLoading },
    searchTerm = '',
  }) => {
    const navigate = useNavigate();
    const [filterParams, setFilterParams] = useState({});

    useEffect(() => {
      if (branchId) {
        getSuppliers({ ...filterParams });
      }
    }, [filterParams, branchId, getSuppliers]);

    const filteredSuppliers = useMemo(() => {
      const term = (searchTerm || '').trim().toLowerCase();
      const rows = suppliersData || [];
      if (!term) return rows;
      return rows.filter((row) => {
        const companyName = String(row.companyname || '').toLowerCase();
        const contactNo = String(row.contact_no || '').toLowerCase();
        return companyName.includes(term) || contactNo.includes(term);
      });
    }, [suppliersData, searchTerm]);

    const columns = [
      { id: 'companyname', label: 'Company Name', minWidth: 100 },
      { id: 'address', label: 'Address', minWidth: 100 },
      { id: 'contact_no', label: 'Contact No', minWidth: 100 },
      {
        id: 'options',
        minWidth: 20,
        options: ['View', 'Update'],
        table: 'supplier',
        customHandlers: {
          onViewImage: (id) => navigate(`/inventory/suppliers/view/${id}`),
        },
      },
    ];

    return (
      <div className={styles.wrapper}>
        {isLoading ? (
          <div className={styles.loadingWrap}>
            <Loading variant="inline" label="" />
          </div>
        ) : (
          <Table columns={columns} rows={filteredSuppliers} />
        )}
      </div>
    );
  }
);

SupplierTable.propTypes = {
  getSuppliers: PropTypes.func.isRequired,
  auth: PropTypes.shape({
    branchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  suppliersState: PropTypes.shape({
    suppliersData: PropTypes.array,
    isLoading: PropTypes.bool,
  }).isRequired,
  searchTerm: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: state.authState,
  suppliersState: state.suppliersState,
});

export default connect(mapStateToProps, {
  getSuppliers,
})(SupplierTable);
